import { render } from "./LogisticsHelp.vue?vue&type=template&id=33e6345c"
import script from "./LogisticsHelp.vue?vue&type=script&lang=js"
export * from "./LogisticsHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__